export * from './src/galaxy-three-panel.module';
